import React, { useState, useEffect, useRef } from "react";
import "./ScorePopup.css";

const W = 248;
const H = 240;

// Small popover anchored near the click. Confirms a winner; when scoring is
// enabled it also collects the winner's and loser's scores.
function ScorePopup({
  winner,
  loser,
  scoringEnabled,
  position,
  onConfirm,
  onCancel,
}) {
  const [winnerScore, setWinnerScore] = useState("");
  const [loserScore, setLoserScore] = useState("");
  const ref = useRef(null);
  const firstFieldRef = useRef(null);

  useEffect(() => {
    firstFieldRef.current?.focus();
    function onKey(e) {
      if (e.key === "Escape") onCancel();
    }
    function onDown(e) {
      if (ref.current && !ref.current.contains(e.target)) onCancel();
    }
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onDown);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onDown);
    };
  }, [onCancel]);

  function confirm() {
    if (!scoringEnabled) return onConfirm(null, null);
    const w = winnerScore.trim() === "" ? null : parseInt(winnerScore, 10);
    const l = loserScore.trim() === "" ? null : parseInt(loserScore, 10);
    onConfirm(Number.isNaN(w) ? null : w, Number.isNaN(l) ? null : l);
  }

  const style = {
    left: Math.max(8, Math.min(position.x, window.innerWidth - W - 8)),
    top: Math.max(8, Math.min(position.y, window.innerHeight - H - 8)),
  };

  return (
    <div className="score-popup" style={style} ref={ref}>
      <div className="score-popup-title">Confirm Winner</div>
      <div className="score-popup-winner">{winner}</div>

      {scoringEnabled && (
        <>
          <label className="score-popup-field">
            <span className="score-popup-name">{winner}</span>
            <input
              ref={firstFieldRef}
              className="score-popup-input"
              type="number"
              value={winnerScore}
              onChange={(e) => setWinnerScore(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && confirm()}
            />
          </label>
          <label className="score-popup-field">
            <span className="score-popup-name">{loser}</span>
            <input
              className="score-popup-input"
              type="number"
              value={loserScore}
              onChange={(e) => setLoserScore(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && confirm()}
            />
          </label>
        </>
      )}

      <div className="score-popup-actions">
        <button className="score-popup-cancel" onClick={onCancel}>
          Cancel
        </button>
        <button
          className="score-popup-confirm"
          ref={scoringEnabled ? null : firstFieldRef}
          onClick={confirm}
        >
          Confirm
        </button>
      </div>
    </div>
  );
}

export default ScorePopup;
